<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h6>{{ $t('edit_configuration') }}</h6>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/setting/list" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <form @submit.prevent="updateSetting" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <!-- Batch Policy -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("batch_policy") }}</label>
                    <select v-model="setting.batch_policy" class="form-select">
                      <option value="FIFO">FIFO</option>
                      <option value="FEFO">FEFO</option>
                    </select>
                    <div v-if="errors.batch_policy" class="text-danger mt-1">{{ errors.batch_policy }}</div>
                  </div>

                  <!-- Discount Policy -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("discount_policy") }}</label>
                    <select v-model="setting.discount_policy" class="form-select">
                      <option value="Record in Accounts">Record in Accounts</option>
                      <option value="Show Only on Invoice">Show Only on Invoice</option>
                    </select>
                    <div v-if="errors.discount_policy" class="text-danger mt-1">{{ errors.discount_policy }}</div>
                  </div>

                  <!-- Vat Percentage -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("global_vat_percentage") }}</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      v-model="setting.global_vat_percentage"
                      class="form-control"
                      placeholder="e.g., 15.00"
                    >
                    <div v-if="errors.vat_percentage" class="text-danger mt-1">{{ errors.vat_percentage }}</div>
                  </div>

                  <!-- Vat Policy -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("vat_policy") }} </label>
                    <select v-model="setting.vat_policy" class="form-select">
                      <option value="No VAT">No VAT</option>
                      <option value="Price including Global VAT">Price including Global VAT</option>
                      <option value="Price excluding Global VAT">Price excluding Global VAT</option>
                      <option value="Price including Item-wise VAT">Price including Item-wise VAT</option>
                      <option value="Price excluding Item-wise VAT">Price excluding Item-wise VAT</option>
                    </select>
                    <div v-if="errors.vat_policy" class="text-danger mt-1">{{ errors.vat_policy }}</div>
                  </div>

                  <!-- Invoice style -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("invoice_style") }} </label>
                    <select v-model="setting.invoice_style" class="form-select">
                      <option value="A4">A4</option>
                      <option value="Thermal(80mm)">Thermal(80mm)</option>
                    </select>
                    <div v-if="errors.invoice_style" class="text-danger mt-1">{{ errors.invoice_style }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 text-end">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </div>
  </form>
</div>
</template>


<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import VueSelect2 from "vue3-select2-component";
import {useToast} from "vue-toastification";

export default {
  components: {
    Vue3Datepicker,
    VueSelect2,
  },

  props: ['id'],

  data() {
    return {
      setting: {
       batch_policy: 'FIFO',
       discount_policy: 'Show Only on Invoice',
       global_vat_percentage: null,
       vat_policy: 'No VAT',
       invoice_style: 'A4'
    },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  mounted() {
    this.fetchSetting();
  },

  methods: {
    async fetchSetting() {
      try {
        const response = await this.$axios.get(`${apiUrls.setting.get}${this.id}/`);
        this.setting = response.data;
      } catch (error) {
        this.$toast.error(this.$t('error_fetching_settings'));
      }
    },

    async updateSetting() {
      // Frontend validation before making API call
        this.errors = {};
        if (!this.setting.batch_policy) this.errors.batch_policy = this.$t('error.required');

        if (Object.keys(this.errors).length > 0) {
          return;
      }

      try {
        const response = await this.$axios.put(apiUrls.setting.update(this.id), this.setting);

        this.toast.success('inventory setting successfully updated!')

        // Redirect only after successful response
        this.$router.push('/setting/list');

        // Emit event to update parent component
        this.$emit("create_success");

        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        // Handle field-specific errors dynamically
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
      }
    },

    cancelForm() {
        this.$router.push('/setting/list');
      },

    resetForm() {
        // Reset form fields and errors
        this.setting = {
          batch_policy: 'FIFO',
          discount_policy: 'Show Only on Invoice',
          global_vat_percentage: null,
          vat_policy: 'No VAT',
          invoice_style: 'A4'
        };
        this.errors = {};
        this.errorMessage = "";
      }
  },
};
</script>
